module.exports = __webpack_public_path__ + "fonts/7efefa4ced476881ecad32dfc7b61cfe.otf";